import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import PageGuardPSPegawai from 'app/KinerjaPSPegawaiPage/components/PageGuardPSPegawai'
import KinerjaNotifikasiIndex from 'app/KinerjaPSPegawaiPage/pages/Notifikasi'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isNotifikasiEnabled =
      process.env.NEXT_PUBLIC_SKP_NOTIFIKASI_ENABLED === 'true'
    const isPageEnabled = toggle?.['kinerja-ps-pegawai-enabled'] || false
    const isNotificationEnabled =
      toggle?.['kinerja-ps-pegawai-notification-enabled'] || false

    if (!isNotifikasiEnabled || !isPageEnabled || !isNotificationEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const Page = (_props: PageProps) => (
  <PageGuardPSPegawai>
    <KinerjaNotifikasiIndex />
  </PageGuardPSPegawai>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  pageTitle: 'Pengelolaan Kinerja',
}

export default Page
